import { Input } from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { useEffect, useState } from "react";
import {
  Button,
  ButtonGroup,
  ButtonToolbar,
  InputGroup,
} from "react-bootstrap";
import DatePicker from "react-date-picker";
import { useDispatch, useSelector } from "react-redux";
import { error_codes } from "../ConstVariable";
import {
  callRecordFunc,
  centerPreFixFunc,
  centerSelectFunc,
  clearConversationIdFunc,
  statusListCallHistoryFunc,

} from "../redux-store/actions";
import MultiSelectionDropdown from "../UI/CustomMultiSelectionDropDown/MultiSelectionDropdown";
import Centerlist from "./Centerlist";
import "./Filterbar.css";
import StatusCodeList from "./StatusCodeList";
import { Switch } from 'devextreme-react/switch';
import { useAuth0 } from "@auth0/auth0-react";
import {RadioGroup} from 'devextreme-react/radio-group';
//NOTE: Call source list
const callSourceTypeList = [
  { id: "WEBBOT", call_source: "WEBBOT", isChecked: false },
  { id: "LANDLINE", call_source: "LANDLINE", isChecked: false },
  { id: "MANUAL", call_source: "MANUAL", isChecked: false },
  { id: "MOBILE", call_source: "MOBILE", isChecked: false },
];

const FilterBar = ({
  fromDate,
  toDate,
  callerId,
  ConversationSearch,
  callStatus,
  CallCenter,
  InputHandler,
  SearchHandle,

  ResetHandler,
  getTokenFunc,
  callStatusCodeListHandler,
  cenetrCodeListHandler,
  componentIdentity,
  call_status_list,
  center_list,
  centerListArr,
  callSourceListHandler,
  callSourceList,
  totalNumberOfCall,
  gotNoOfCalls,
  noOfCallsText,
  lastName,
  firstName,
  dob,
  dobChangeHandler,
  utterance,
  callDateTypeHandler,
  callDateType
}) => {
  const { user } = useAuth0();

  const [callSource, setCallSource] = useState(callSourceTypeList);

  const [showBotErrorDropDown, setShowBotErrorDropDown] = useState(false);
  const [resetSelecteBotError, setRsetSelecteBotError] = useState(false);

  useEffect(() => {
    let list = callSource;
    for (let i = 0; i < list.length; i++) {
      list[i].isChecked = false;
    }
    setCallSource(list);
  }, [componentIdentity]);

  const [resetClick, setResetClick] = useState(false);

  const reduxState = useSelector((state) => state);

  const workdeskCenterList = reduxState.CenterList;
  const callhistoryCenterList = reduxState.CenterListCallHistory;
  const workdeskCallStatusList = reduxState.CallStatusWorkdeskList;
  const callhistoryCallStatusList = reduxState.CallStatusCallHistoryList;
  const dispatch = useDispatch();

  const [displayStatusList, setDisplayStatusList] = useState("none");

  const [callSourceListShow, setCallSourceListShow] = useState("none");

  const [CallStatusList, setCallStatusList] = useState([]);
  useEffect(() => {
    dispatch(statusListCallHistoryFunc(CallStatusList));
  }, [CallStatusList]);

  // console.log("ComponentIdentity", componentIdentity);
  // console.log("call_status_list", call_status_list);
  // console.log("center_list", center_list);
  let AI_CALL = null;
  if (call_status_list) {
    AI_CALL = call_status_list.filter((item) => {
      return item.operator_feedback.toString().substring(0, 3) == "100";
    });

    //NOTE:- Adding a new key isChecked
    for (let i = 0; i < AI_CALL.length; i++) {
      AI_CALL[i]["isChecked"] = false;
    }
  }
  let USER_DISCONNECT = null;
  if (call_status_list) {
    USER_DISCONNECT = call_status_list.filter((item) => {
      return item.operator_feedback.toString().substring(0, 3) == "200";
    });
    for (let i = 0; i < USER_DISCONNECT.length; i++) {
      USER_DISCONNECT[i]["isChecked"] = false;
    }
  }
  let AI_ESCALATE = null;
  if (call_status_list) {
    AI_ESCALATE = call_status_list.filter((item) => {
      return item.operator_feedback.toString().substring(0, 3) == "300";
    });
    for (let i = 0; i < AI_ESCALATE.length; i++) {
      AI_ESCALATE[i]["isChecked"] = false;
    }
  }

  //NOTE :- To Show callStatus and Center list
  const [showCallStatus, setShowCallStatus] = useState(false);
  const [showCenterList, setShowCenterList] = useState(false);

  // NOTE:- Toggling the callStatus and Centerlist component
  const toggleFunc = () => {
    setCallSourceListShow("none");
    //NOTE:- To show status list on click
    if (!showCallStatus) {
      setDisplayStatusList("");
    } else {
      setDisplayStatusList("none");
    }
    setShowCallStatus(() => !showCallStatus);
    setShowCenterList(false);
  };
  const centerListToggle = () => {
    setCallSourceListShow("none");
    setDisplayStatusList("none");
    setShowCenterList(!showCenterList);
    setShowCallStatus(false);
  };

  const searchHandler = () => {
    setCallSourceListShow("none");
    setDisplayStatusList("none");
    dispatch(callRecordFunc(null));
    SearchHandle();
    setShowCenterList(false);
    setShowCallStatus(false);
    dispatch(clearConversationIdFunc());
    dispatch(centerPreFixFunc(null));
    dispatch(centerSelectFunc(null));
    setShowBotErrorDropDown(false);
  };

  const resetchangeHandler = () => {
    setRsetSelecteBotError(true);

    callSourceListHandler([]);
    setCallSourceListShow("none");
    setResetClick(!resetClick);
    dispatch(callRecordFunc(null));
    ResetHandler();
    setDisplayStatusList("none");
    dispatch(statusListCallHistoryFunc([]));
    setShowCenterList(false);
    setShowCallStatus(false);

    let list = callSource;
    for (let i = 0; i < list.length; i++) {
      list[i].isChecked = false;
    }
    setCallSource(list);
    dispatch(clearConversationIdFunc());
    dispatch(centerPreFixFunc(null));
    dispatch(centerSelectFunc(null));
    setShowBotErrorDropDown(false);
  };

  const cneterSelectedNo = () => {
    if (componentIdentity === "workdesk" && reduxState.CenterListCallHistory) {
      return (
        <span style={{ fontSize: "15px", fontWeight: "600" }}>
          {reduxState.CenterListCallHistory.length} selected
        </span>
      );
    } else if (
      (componentIdentity === "callhistory" ||
        componentIdentity === "Trashcall") &&
      callhistoryCenterList != null &&
      callhistoryCenterList.length != 0
    ) {
      return (
        <span style={{ fontSize: "15px", fontWeight: "600" }}>
          {callhistoryCenterList.length} selected
        </span>
      );
    }
  };

  const callStatusSelectedNo = () => {
    if (
      callhistoryCallStatusList != null &&
      callhistoryCallStatusList.length !== 0
    ) {
      return (
        <span style={{ fontSize: "15px", fontWeight: "600" }}>
          {callhistoryCallStatusList.length} selected
        </span>
      );
    }
  };

  //CallSource dropdown toggle function

  const callSourceDropdownToggle = () => {
    setCallSourceListShow("none");
    setShowCenterList(false);

    setDisplayStatusList("none");
    if (callSourceListShow === "none") {
      setCallSourceListShow("");
    } else {
      setCallSourceListShow("none");
    }
  };

  const callSourceCheckHandler = (e, id) => {
    setCallSourceListShow("");

    if (e.target.checked) {
      let arr = callSourceList;
      let list = callSource;
      // NOTE:- here we are making a check box true
      for (let i = 0; i < callSource.length; i++) {
        if (callSource[i].id === id) {
          callSource[i].isChecked = true;
        }
      }

      arr.push(id);
      callSourceListHandler(arr);
      setCallSource(list);
      // console.log("ARRAY ", arr);
    } else {
      let arr = callSourceList.filter((Id) => id != Id);
      let list = callSource;

      // NOTE:- here we are making a check box false
      for (let i = 0; i < callSource.length; i++) {
        if (callSource[i].id === id) {
          callSource[i].isChecked = false;
        }
      }
      setCallSource(list);
      callSourceListHandler(arr);
    }

    // InputHandler(e);
    // console.log("Call Source Event", e.target.checked);
  };

  useEffect(() => {}, [workdeskCenterList, callhistoryCenterList, callSource]);

  const priorities =["Call Date", "Appt. Date"]
  return (
    <div
      className="border"
      style={{
        backgroundColor: "#DADCD3",
        paddingLeft: "10px",
        marginBottom: "7px",
        height: "100%",
      }}
    >
      <div className="d-flex searchmenu mr-6 " style={{ alignItems: "center" }}>
        <ButtonToolbar>
          <InputGroup style={{ display: "flex", alignItems: "center" }}>
            <div className="search" style={{ marginRight: "4px" }}>
              <label style={{ marginRight: "4px" }}>FName</label>

              <Input
                type="text"
                style={{ width: "150px" }}
                name="firstName"
                value={firstName}
                onChange={InputHandler}
              />
            </div>
            <div className="search" style={{ marginRight: "4px" }}>
              <label style={{ marginRight: "4px" }}>LName</label>

              <Input
                type="text"
                style={{ width: "150px" }}
                name="lastName"
                value={lastName}
                onChange={InputHandler}
              />
            </div>
            <div className="search" style={{ marginRight: "4px" }}>
              <label style={{ marginRight: "6px" }}>DOB</label>
              <DatePicker
                onChange={dobChangeHandler}
                value={dob}
                disableCalendar={true}
                format="dd/MM/y"
                clearIcon={true}
                dayPlaceholder="DD"
                monthPlaceholder="MM"
                yearPlaceholder="YYYY"
              />
            </div>
            {/* <div className="search">
            <Switch switchedOffText={"Appt. Date"} switchedOnText={"Call Date"} width={"100"} onValueChange={(e)=>{
              console.log("onValueChange",e)
            }} />
            </div> */}
            {componentIdentity != "Trashcall" &&<div className="search"  style={{ marginRight: "10px" }} >
            <RadioGroup items={priorities} defaultValue={priorities[0]} value={callDateType} layout="horizontal" onValueChange={(e)=>{
              callDateTypeHandler(e)
            }}  />
            </div>}
            <div className="search" style={{ marginRight: "4px" }}>
              <label style={{ marginRight: "6px" }}>FROM</label>

              <Input
                type="date"
                name="fromDate"
                value={fromDate}
                onChange={InputHandler}
              />
            </div>
            <div className="search" style={{ marginRight: "4px" }}>
              <label style={{ marginRight: "6px" }}>TO</label>

              <Input
                type="date"
                name="toDate"
                value={toDate}
                onChange={InputHandler}
              />
            </div>
            <div className="search" style={{ marginRight: "4px" }}>
              <label style={{ marginRight: "4px" }}>Ph#</label>

              <Input
                type="text"
                style={{ width: "140px" }}
                name="callerId"
                value={callerId}
                onChange={InputHandler}
              />
            </div>
            <div className="search" style={{ marginRight: "4px" }}>
              <label style={{ marginRight: "4px" }}>Conv#</label>

              <Input
                type="text"
                style={{ width: "200px" }}
                name="ConversationSearch"
                value={ConversationSearch}
                onChange={InputHandler}
              />
            </div>



            <div style={{ position: "relative" }}>
              <div
                className="search "
                id="centerlist"
                style={{
                  borderBottom: "1px solid black",
                  fontSize: "15px",
                  fontWeight: "600",
                  marginRight: "10px",
                  cursor: "pointer",
                  color: "#586C72",
                }}
                onClick={centerListToggle}
              >
                {(workdeskCenterList != null &&
                  workdeskCenterList.length !== 0) ||
                (callhistoryCenterList != null &&
                  callhistoryCenterList.length !== 0)
                  ? cneterSelectedNo()
                  : "CENTER"}

                <span style={{ marginLeft: "5px" }}>
                  <ArrowDropDownIcon />
                </span>
              </div>
              <div
                style={{
                  position: "absolute",
                  top: "40px",
                  zIndex: "100",
                  width: "250px",
                }}
              >
                {showCenterList && (
                  <Centerlist
                    center_list={center_list}
                    closeModal={centerListToggle}
                    centerListArr={centerListArr}
                    componentIdentity={componentIdentity}
                    showCenterList={showCenterList}
                    setShowCenterList={(val) => setShowCenterList(val)}
                  />
                )}
              </div>
            </div>




            <div>
              <div
                style={{
                  borderBottom: "1px solid black",

                  fontSize: "15px",
                  fontWeight: "600",
                  marginRight: "10px",
                  cursor: "pointer",
                  color: "#586C72",
                }}
                onClick={toggleFunc}
              >
                {(workdeskCallStatusList != null &&
                  workdeskCallStatusList.length != 0) ||
                (callhistoryCallStatusList != null &&
                  callhistoryCallStatusList.length != 0)
                  ? callStatusSelectedNo()
                  : "CALL STATUS"}
                <span style={{ marginLeft: "5px" }}>
                  <ArrowDropDownIcon />
                </span>
              </div>

              <div
                className="callstatuslist"
                style={{
                  position: "absolute",
                  top: "40px",
                  right: "0px",
                  zIndex: "100",
                  display: displayStatusList,
                }}
              >
                <StatusCodeList
                  AI_CALL={AI_CALL}
                  AI_ESCALATE={AI_ESCALATE}
                  USER_DISCONNECT={USER_DISCONNECT}
                  closeModal={toggleFunc}
                  callStatusCodeListHandler={callStatusCodeListHandler}
                  componentIdentity={componentIdentity}
                  showCallStatus={showCallStatus}
                  setShowCallStatus={(val) => setShowCallStatus(val)}
                  displayStatusList={displayStatusList}
                  setCallStatusList={(val) => setCallStatusList(val)}
                  resetClick={resetClick}
                />
              </div>
            </div>


            
            <div
              style={{
                borderBottom: "1px solid",
                position: "relative",
                marginRight: "15px",
                cursor: "pointer",
              }}
              onClick={callSourceDropdownToggle}
            >
              <span
                style={{
                  fontWeight: "600",
                  color: "#586C72",
                }}
              >
                {callSourceList !== undefined || callSourceList.length == 0 ? (
                  <span>CALL SOURCE</span>
                ) : (
                  <span> {callSourceList.length} Selected </span>
                )}
              </span>
              <span style={{ marginLeft: "5px" }}>
                <ArrowDropDownIcon />
              </span>
              <div
                className="filterbar__callsource"
                style={{ display: callSourceListShow }}
              >
                {callSource.map((item) => (
                  <div className="filterbar__dropdown" key={item.call_source}>
                    <input
                      type="checkbox"
                      checked={item.isChecked}
                      style={{ marginRight: "5px", marginLeft: "10px" }}
                      onChange={(e) => callSourceCheckHandler(e, item.id)}
                    />
                    <span style={{ fontSize: "15px" }}>{item.call_source}</span>
                  </div>
                ))}
                <center
                  className="filterbar__callSource__done"
                  onClick={callSourceDropdownToggle}
                >
                  Done
                </center>
              </div>
            </div>

            {componentIdentity === "callhistory" &&
              user.profile &&
              user.profile.toLowerCase() === "oi-admin" && (
                <div style={{ width: "300px" }}>
                  <MultiSelectionDropdown
                    options={error_codes}
                    showBotErrorDropDown={showBotErrorDropDown}
                    setShowBotErrorDropDown={(val) =>
                      setShowBotErrorDropDown(val)
                    }
                    setRsetSelecteBotError={(val) =>
                      setRsetSelecteBotError(val)
                    }
                    resetSelecteBotError={resetSelecteBotError}
                    resetClick={resetClick}
                  />
                </div>
              )}
              {
                componentIdentity === "callhistory" && user?.profile &&
              user?.profile.toLowerCase() === "oi-admin" && 
              
            <div className="search" style={{ marginRight: "4px" }}>
              <label style={{ marginRight: "4px" }}>Utterance</label>

              <Input
                type="text"
                style={{ width: "200px" }}
                name="utterance"
                value={utterance}
                onChange={InputHandler}
              />
            </div>
              }

            <ButtonGroup size="sm">
              <Button
                variant="primary"
                onClick={searchHandler}
                size="sm"
                style={{ marginRight: "5px" }}
              >
                Search
              </Button>
              <Button variant="warning" onClick={resetchangeHandler} size="sm">
                Reset
              </Button>
            </ButtonGroup>
            {gotNoOfCalls != null && gotNoOfCalls != 0 && (
              <div
                style={{
                  background: "yellow",
                  color: "red",
                  fontWeight: "bolder",
                  height: "29px",
                  marginLeft: "10px",
                }}
              >
                <span style={{ borderBottom: "2px solid red" }}>
                  {noOfCallsText()} of {totalNumberOfCall} Records{" "}
                </span>
              </div>
            )}
          </InputGroup>
        </ButtonToolbar>
      </div>
    </div>
  );
};

export default FilterBar;
